import HARDCODE from '../../../business-const/HardCode/HardCode'

import MESSAGE from '../../../business-const/Message/Message'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import AuthService from '../../../business-api/AuthService'

//import ClienteService from '../../../business-api/ClienteService'

import {
    dataAtual,
    formataData,
} from '../../../business-components/Date/Date'

import {
    calcEstudoReportCapaTitulo1,
    calcProfissaoQualificacao,
} from './EstudoReportService'



const EstudoReportDisclaimer = ({ variaveisGlobais, values, vars }) => {

    const estudoReportCapaTitulo1 = calcEstudoReportCapaTitulo1(vars)
    const profissaoQualificacao = calcProfissaoQualificacao(vars.jsonUsuario)

    return (
        <div
            align="left"
            //className="ml-5 mt-0 mr-5" /* mudança da fonte: mt-5 */
        >
            <div
                className={
                    values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato
                        ?
                            CLASSNAME().formataReportDisclaimerRetrato
                        :
                            CLASSNAME().formataReportDisclaimerPaisagem
                }
                dangerouslySetInnerHTML={{ __html: 
                    vars.jsonConfiguracao && vars.jsonConfiguracao.estudoReportDisclaimer
                        ?
                            vars.jsonConfiguracao.estudoReportDisclaimer
                                .replaceAll(HARDCODE.estudoReportCapaTitulo1, estudoReportCapaTitulo1)
                                    .replaceAll(HARDCODE.profissaoQualificacao, profissaoQualificacao) + 
                                        '<br/><br/>' +
                                            MESSAGE().estudoReportPrimeiraReuniaoTextoSegurancaDados
                        :
                            MESSAGE().estudoReportDisclaimer
                                .replaceAll(HARDCODE.estudoReportCapaTitulo1, estudoReportCapaTitulo1)
                                    .replaceAll(HARDCODE.profissaoQualificacao, profissaoQualificacao) + 
                                        '<br/><br/>' +
                                            MESSAGE().estudoReportPrimeiraReuniaoTextoSegurancaDados
                }}
            />
            
            <div
                className='mt-15'
                dangerouslySetInnerHTML={{ __html: 
                    MESSAGE().elaboradoPor
                        .replace("$1$", formataData(dataAtual()))
                            .replace("$2$", AuthService.obterIdentificacaoUsuarioLogado(variaveisGlobais)/*ClienteService.obterUsuarioClienteSelecionadoIdentificacao(variaveisGlobais)*/)
                                .replace("$3$", AuthService.obterEmailUsuarioLogado(variaveisGlobais))
                }}
            />
        </div>
    )
}

export default EstudoReportDisclaimer